// import { useWishlist } from "../../context/WishlistContext";
// import { PRODUCTS } from "../../data/siteData";
// import wishlistBanner from "../../assets/images/product-banner-2.png";
// import "./Wishlist.css";

// function Wishlist({ onNavigate }) {
//   const { items, toggleItem } = useWishlist();

//   // Wishlist context ki item IDs ko matches karke siteData se product details lana
//   const wishlistedProducts = PRODUCTS.filter((product) =>
//     items.includes(product.id)
//   );

//   return (
//     <main className="wishlist-page">
//       {/* HERO BANNER SECTION */}
//       <section className="wishlist-hero">
//         <div
//           className="wishlist-hero-bg"
//           style={{ backgroundImage: `url(${wishlistBanner})` }}
//         />
//         <div className="wishlist-hero-overlay" />

//         <div className="wishlist-hero-content">
//           <h1 className="wishlist-title">MY WISHLIST</h1>
//           <p className="wishlist-subtitle">Your Saved Skincare Essentials</p>

//           <div className="wishlist-logo-watermark">
//             <span className="logo-symbol">✨</span>
//             <p className="logo-text">YOUR CARE</p>
//             <span className="logo-tagline">Care that Clicks</span>
//           </div>
//         </div>
//       </section>

//       {/* MAIN WISHLIST CONTENT */}
//       <section className="wishlist-container">
//         {wishlistedProducts.length === 0 ? (
//           /* EMPTY WISHLIST STATE */
//           <div className="empty-wishlist-card">
//             <div className="heart-icon-wrapper">
//               <svg
//                 width="64"
//                 height="64"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="1.2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
//               </svg>
//             </div>

//             <h2 className="empty-title">Your Wishlist is Empty</h2>

//             <p className="empty-description">
//               Explore our science-backed skincare formulas and save your favorites here.
//             </p>

//             {/* Custom Navigation Button (React Router <Link> ki jagah) */}
//             <button
//               type="button"
//               className="discover-btn"
//               onClick={() => onNavigate && onNavigate("/products")}
//             >
//               Discover Products
//             </button>
//           </div>
//         ) : (
//           /* WISHLIST ITEMS GRID */
//           <div className="wishlist-grid-wrapper">
//             <h2 className="saved-items-heading">
//               Saved Items ({wishlistedProducts.length})
//             </h2>

//             <div className="wishlist-grid">
//               {wishlistedProducts.map((product) => (
//                 <div key={product.id} className="wishlist-item-card">
//                   <button
//                     type="button"
//                     className="remove-btn"
//                     onClick={() => toggleItem(product.id)}
//                     title="Remove item"
//                   >
//                     ✕
//                   </button>

//                   <div className="item-image-box">
//                     <img src={product.image} alt={product.name} />
//                   </div>

//                   <div className="item-details">
//                     <span className="item-category">SKINCARE</span>
//                     <h3 className="item-name">{product.name}</h3>
//                     <p className="item-price">
//                       {product.price ? `${product.currency} ${product.price}` : "Coming Soon"}
//                     </p>

//                     <div className="item-actions">
//                       <button type="button" className="add-to-cart-btn">
//                         Add to Cart
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </section>
//     </main>
//   );
// }

// export default Wishlist;
import { useWishlist } from "../../context/WishlistContext";
import { useCart } from "../../context/CartContext";
import { PRODUCTS } from "../../data/siteData";
import wishlistBanner from "../../assets/images/product-banner-2.png";
import "./Wishlist.css";

function Wishlist({ onNavigate }) {
  const { items, toggleItem } = useWishlist();
  const { addItem } = useCart();

  // Wishlist context ki item IDs ko matches karke siteData se product details lana
  const wishlistedProducts = PRODUCTS.filter((product) =>
    items.includes(product.id)
  );

  const handleAddToCart = (product) => {
    addItem(product);
    onNavigate && onNavigate("/cart"); // cart page par le jao
  };

  return (
    <main className="wishlist-page">
      {/* HERO BANNER SECTION */}
      <section className="wishlist-hero">
        <div
          className="wishlist-hero-bg"
          style={{ backgroundImage: `url(${wishlistBanner})` }}
        />
        <div className="wishlist-hero-overlay" />

        <div className="wishlist-hero-content">
          <h1 className="wishlist-title">MY WISHLIST</h1>
          <p className="wishlist-subtitle">Your Saved Skincare Essentials</p>

          <div className="wishlist-logo-watermark">
            <span className="logo-symbol">✨</span>
            <p className="logo-text">YOUR CARE</p>
            <span className="logo-tagline">Care that Clicks</span>
          </div>
        </div>
      </section>

      {/* MAIN WISHLIST CONTENT */}
      <section className="wishlist-container">
        {wishlistedProducts.length === 0 ? (
          /* EMPTY WISHLIST STATE */
          <div className="empty-wishlist-card">
            <div className="heart-icon-wrapper">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>

            <h2 className="empty-title">Your Wishlist is Empty</h2>

            <p className="empty-description">
              Explore our science-backed skincare formulas and save your favorites here.
            </p>

            {/* Custom Navigation Button (React Router <Link> ki jagah) */}
            <button
              type="button"
              className="discover-btn"
              onClick={() => onNavigate && onNavigate("/products")}
            >
              Discover Products
            </button>
          </div>
        ) : (
          /* WISHLIST ITEMS GRID */
          <div className="wishlist-grid-wrapper">
            <h2 className="saved-items-heading">
              Saved Items ({wishlistedProducts.length})
            </h2>

            <div className="wishlist-grid">
              {wishlistedProducts.map((product) => {
                const hasPrice = product.price != null; // 0 ko bhi valid price maano
                return (
                  <div key={product.id} className="wishlist-item-card">
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => toggleItem(product.id)}
                      title="Remove item"
                    >
                      ✕
                    </button>

                    <div className="item-image-box">
                      <img src={product.image} alt={product.name} />
                    </div>

                    <div className="item-details">
                      <span className="item-category">SKINCARE</span>
                      <h3 className="item-name">{product.name}</h3>
                      <p className="item-price">
                        {hasPrice
                          ? `${product.currency} ${product.price.toLocaleString()}`
                          : "Coming Soon"}
                      </p>

                      <div className="item-actions">
                        <button
                          type="button"
                          className="add-to-cart-btn"
                          disabled={!hasPrice}
                          onClick={() => handleAddToCart(product)}
                        >
                          {hasPrice ? "Add to Cart" : "Coming Soon"}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </section>
    </main>
  );
}

export default Wishlist;